export const cateringMenuItems = [
  {
    id: 1,
    category: 'Breakfast',
    name: 'Breakfast Croissant Tray',
    description: 'Assorted croissants filled with savory breakfast ingredients',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/p61re4tp_477047897_946735490923808_32674825393354609_n.jpg',
    servings: '12-15 people'
  },
  {
    id: 2,
    category: 'Breakfast',
    name: 'Sausage Biscuit Sliders',
    description: 'Homemade flaky biscuits with savory sausage patties',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/x3oz82n5_c6d13b47-d99e-4a96-af53-525f58da04a0.jpg',
    servings: '12-15 people'
  },
  {
    id: 3,
    category: 'Breakfast',
    name: 'Ham Biscuit Sliders',
    description: 'Fresh baked biscuits with premium ham - perfect for breakfast or brunch',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/xvv7579g_599514498_1153866210252514_8262617886031627932_n.jpg',
    servings: '12-15 people'
  },
  {
    id: 4,
    category: 'Breakfast',
    name: 'Fresh Baked Biscuits',
    description: 'Warm, flaky homemade biscuits perfect for any breakfast spread',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/3mgpp3oe_f26c46dc-264d-402b-af91-cc98c3adc59f.jpg',
    servings: '12-20 people'
  },
  {
    id: 5,
    category: 'Lunch',
    name: 'Taco Bar',
    description: 'Complete taco bar setup with all the fixings - perfect for large gatherings',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/odboqiiq_e580c93a-1009-4ff7-8100-6e1f685201be.jpg',
    servings: '20-30 people'
  },
  {
    id: 6,
    category: 'Lunch',
    name: 'Wrap Platter',
    description: 'Fresh wraps with turkey, ham, and veggie options',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/6uh7xrwt_473157863_926496512947706_410804654689645572_n.jpg',
    servings: '12-15 people'
  },
  {
    id: 7,
    category: 'Lunch',
    name: 'Wrap Pinwheels with Dip',
    description: 'Colorful wrap pinwheels with fresh vegetables and homemade dip',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/3q2ru9mx_473242873_926511859612838_5925297766836975290_n.jpg',
    servings: '12-15 people'
  },
  {
    id: 8,
    category: 'Lunch',
    name: 'Party Tray',
    description: 'Mini sliders with ham, turkey, and sausage options - perfect for any gathering',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/yhtx9eg6_476402542_946735560923801_5528077024555438637_n.jpg',
    servings: '15-20 people'
  },
  {
    id: 9,
    category: 'Supper',
    name: 'Spaghetti',
    description: 'Homemade meat sauce with tender pasta - a classic comfort dish',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/wewhucpd_471427033_917935053803852_1811960546536180765_n.jpg',
    servings: '15-20 people'
  },
  {
    id: 10,
    category: 'Supper',
    name: 'Pasta Bar',
    description: 'Choice of pasta with marinara, alfredo, or pesto sauce',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/xbouzyz4_471495936_917935190470505_4395504939552086250_n.jpg',
    servings: '15-20 people'
  },
  {
    id: 11,
    category: 'Appetizers',
    name: 'Cookie & Dessert Tray',
    description: 'Assorted homemade cookies, brownies, and sweet treats',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/997cyzj8_473547096_928662969397727_4010279095934232412_n.jpg',
    servings: '15-20 people'
  },
  {
    id: 12,
    category: 'Appetizers',
    name: 'Fresh Fruit Tray',
    description: 'Seasonal fresh fruit beautifully arranged',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/scv8a3m9_471455342_917175790546445_64629705125991556_n.jpg',
    servings: '10-15 people'
  },
  {
    id: 13,
    category: 'Appetizers',
    name: 'Fresh Vegetable Tray',
    description: 'Crisp vegetables with homemade ranch dip',
    image: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/ofkmdg5p_471600108_917175703879787_5936313750658859965_n.jpg',
    servings: '12-15 people'
  }
];

export const weeklyMenuItems = [
  {
    id: 1,
    category: 'Entrees',
    name: 'Spaghetti',
    description: 'Homemade meat sauce with tender pasta'
  },
  {
    id: 2,
    category: 'Entrees',
    name: 'Chicken Alfredo',
    description: 'Creamy alfredo sauce with grilled chicken'
  },
  {
    id: 3,
    category: 'Entrees',
    name: 'Salisbury Steak with Gravy',
    description: 'Classic comfort food with rich gravy'
  },
  {
    id: 4,
    category: 'Entrees',
    name: 'Chicken & Dumplings',
    description: 'Southern-style with fluffy dumplings'
  },
  {
    id: 5,
    category: 'Sides',
    name: 'Green Beans',
    description: 'Fresh green beans seasoned to perfection'
  },
  {
    id: 6,
    category: 'Sides',
    name: 'Mashed Potatoes',
    description: 'Creamy homemade mashed potatoes'
  },
  {
    id: 7,
    category: 'Desserts',
    name: 'Chocolate Cake',
    description: 'Rich, moist chocolate cake'
  },
  {
    id: 8,
    category: 'Desserts',
    name: 'Banana Pudding',
    description: 'Southern classic banana pudding'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'Huntingdon, TN',
    rating: 5,
    text: 'Nanny\'s catered our family reunion and everything was absolutely delicious! The food was fresh, hot, and everyone raved about it. Highly recommend!',
    date: '2 weeks ago'
  },
  {
    id: 2,
    name: 'Mike Patterson',
    location: 'Jackson, TN',
    rating: 5,
    text: 'Best homemade meals in West Tennessee! The weekly menu is always something to look forward to. Feels just like grandma\'s cooking.',
    date: '1 month ago'
  },
  {
    id: 3,
    name: 'Lisa Marie',
    location: 'Huntingdon, TN',
    rating: 5,
    text: 'Greg and Jennifer are amazing! Their party trays are perfect for any occasion. The desserts are to die for!',
    date: '3 weeks ago'
  },
  {
    id: 4,
    name: 'Robert Williams',
    location: 'Camden, TN',
    rating: 5,
    text: 'Ordered catering for our office party and it was a huge hit. Professional service and incredible food quality. Will definitely use them again!',
    date: '1 week ago'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/997cyzj8_473547096_928662969397727_4010279095934232412_n.jpg',
    alt: 'Cookie and dessert tray',
    category: 'Desserts'
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/x3oz82n5_c6d13b47-d99e-4a96-af53-525f58da04a0.jpg',
    alt: 'Sausage biscuit sliders',
    category: 'Breakfast'
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/odboqiiq_e580c93a-1009-4ff7-8100-6e1f685201be.jpg',
    alt: 'Taco bar catering setup',
    category: 'Catering'
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/3mgpp3oe_f26c46dc-264d-402b-af91-cc98c3adc59f.jpg',
    alt: 'Fresh baked biscuits',
    category: 'Breakfast'
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/6uh7xrwt_473157863_926496512947706_410804654689645572_n.jpg',
    alt: 'Fresh wrap platter with tomatoes',
    category: 'Catering'
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/wewhucpd_471427033_917935053803852_1811960546536180765_n.jpg',
    alt: 'Homemade spaghetti with meat sauce',
    category: 'Entrees'
  },
  {
    id: 7,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/yhtx9eg6_476402542_946735560923801_5528077024555438637_n.jpg',
    alt: 'Slider party tray',
    category: 'Catering'
  },
  {
    id: 8,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/p61re4tp_477047897_946735490923808_32674825393354609_n.jpg',
    alt: 'Breakfast croissant tray',
    category: 'Breakfast'
  },
  {
    id: 9,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/xvv7579g_599514498_1153866210252514_8262617886031627932_n.jpg',
    alt: 'Ham biscuit sliders',
    category: 'Breakfast'
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/3q2ru9mx_473242873_926511859612838_5925297766836975290_n.jpg',
    alt: 'Wrap pinwheels with dip',
    category: 'Catering'
  },
  {
    id: 11,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/skggidky_194458672_118464313750934_4431018564693948720_n.jpg',
    alt: 'Hot entree selection',
    category: 'Entrees'
  },
  {
    id: 12,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/37s3aui2_468140482_894918692772155_2120275157885728063_n.jpg',
    alt: 'Party dip platter',
    category: 'Appetizers'
  },
  {
    id: 13,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/xbouzyz4_471495936_917935190470505_4395504939552086250_n.jpg',
    alt: 'Pasta dish',
    category: 'Entrees'
  },
  {
    id: 14,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/sbwfqi03_472970184_926496479614376_2342581467839661898_n.jpg',
    alt: 'Wrap platter original',
    category: 'Catering'
  },
  {
    id: 15,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/myx09vph_471276103_914730380790986_7438305982810000455_n.jpg',
    alt: 'Sandwich and breakfast platter',
    category: 'Catering'
  },
  {
    id: 16,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/ofkmdg5p_471600108_917175703879787_5936313750658859965_n.jpg',
    alt: 'Fresh vegetable tray',
    category: 'Appetizers'
  },
  {
    id: 17,
    url: 'https://customer-assets.emergentagent.com/job_homemade-meals-13/artifacts/scv8a3m9_471455342_917175790546445_64629705125991556_n.jpg',
    alt: 'Charcuterie board',
    category: 'Appetizers'
  }
];

export const serviceAreas = [
  'Huntingdon, TN',
  'Jackson, TN',
  'Camden, TN',
  'Lexington, TN',
  'Paris, TN'
];
